import Vue from 'vue';

export default (app, moduleName, modulePlugins) => {
    if (!modulePlugins) return;

    if (typeof modulePlugins === 'function') return modulePlugins(app);

    modulePlugins.forEach(plugin => Vue.use(plugin, app));
};
